import { useEffect, useState } from "react";
import { Archive, ArchiveRestore, CircleAlert, CirclePlus, Clock3, Eye, Globe, Hammer, ImageOff, PauseCircle, PlayCircle, RotateCcw, Settings2, Undo2, X } from "lucide-react";
import { formatDate, useApi } from "@/lib/api";

const ICON = { created: CirclePlus, queued: Clock3, ready: Hammer, failed: CircleAlert, cancelled: X, preview: Eye, published: Globe, rollback: Undo2,
  suspended: PauseCircle, resumed: PlayCircle, settings: Settings2, archived: Archive, unarchived: ArchiveRestore, requeued: RotateCcw, images_blocked: ImageOff };
const TONE = { failed: "text-red-600", images_blocked: "text-red-600", published: "text-emerald-600", rollback: "text-amber-600", suspended: "text-amber-600", preview: "text-sky-600" };

export default function SiteEvents({ siteId, refreshKey }) {
  const api = useApi();
  const [list, setList] = useState(null);
  useEffect(() => { api.get(`/sites/${siteId}/events`).then(({ data }) => setList(data)).catch(() => setList([])); }, [api, siteId, refreshKey]);
  if (!list) return <p className="text-sm text-slate-500">Caricamento…</p>;
  return (
    <ul className="divide-y divide-slate-100" data-testid="site-events">
      {list.map((e) => {
        const Icon = ICON[e.kind] || Clock3;
        return (
          <li key={e.id} className="flex items-start gap-3 py-2.5" data-testid={`site-event-${e.kind}`}>
            <Icon size={15} className={`mt-0.5 shrink-0 ${TONE[e.kind] || "text-slate-400"}`} />
            <div className="min-w-0 flex-1"><p className="text-sm text-slate-800">{e.message}</p><p className="text-[11px] text-slate-500">{formatDate(e.at, true)}{e.user && ` · ${e.user}`}</p></div>
          </li>
        );
      })}
      {!list.length && <li className="py-4 text-sm text-slate-500">Nessuna attività.</li>}
    </ul>
  );
}
